// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3A2jO","footer":"Form_footer__DOM8M"};